import { useState, createContext } from "react";

const PlanContentPresetsCopyContext = createContext();

export function PlanContentPresetsCopyContextProvider(props) {
	// Global
	const [crudConfOpen, setCrudConfOpen] = useState(false);

	const [crudModel, setCrudModel] = useState(null);

	const [copyPopup, setCopyPopup] = useState(false);

	const [selectedConf, setSelectedConf] = useState(null);

	const [selectedConfId, setSelectedConfId] = useState(null);

	const [planChapters, setPlanChapters] = useState(null);

	const [listConfs, setListConfs] = useState([]);

	const [listOrganizations, setListOrganizations] = useState([]);

	const [planData, setPlanData] = useState({});

	const [organizationData, setOrganizationData] = useState({});

	// Delete

	const [deleteModalOpen, setDeleteModalOpen] = useState(false);

	const [deleteConf, setDeleteConf] = useState({});

	const [deleteItem, setDeleteItem] = useState(null);

	const [updateListConf, setUpdateListConf] = useState(0);

	const [loadingCopyPlan, setLoadingCopyPlan] = useState({
		showDetail: false,
		editConf: false,
		planInfo: false,
		copiers: false,
	});

	const context = {
		crudConfOpen,
		setCrudConfOpen,

		crudModel,
		setCrudModel,

		selectedConf,
		setSelectedConf,

		selectedConfId,
		setSelectedConfId,

		copyPopup,
		setCopyPopup,

		planChapters,
		setPlanChapters,

		planData,
		setPlanData,

		organizationData,
		setOrganizationData,

		listConfs,
		setListConfs,

		deleteModalOpen,
		setDeleteModalOpen,

		deleteConf,
		setDeleteConf,

		deleteItem,
		setDeleteItem,

		updateListConf,
		setUpdateListConf,

		listOrganizations,
		setListOrganizations,

		loadingCopyPlan,
		setLoadingCopyPlan,
	};

	return (
		<PlanContentPresetsCopyContext.Provider value={context}>
			{props.children}
		</PlanContentPresetsCopyContext.Provider>
	);
}

export default PlanContentPresetsCopyContext;
